module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAA8CAYAAABMxmv5AAAAlUlEQVQokXXSwQ7EIAgE0FFB9/+/dkFt9yBjE5u9vQwomJiQcQOAIAEAICmngASk5IVSdaFpoGo9oK0tfNijNZL2gKd20s5EeeG71Pas1wh9FmNJJF4hSkRSpAQyUQJzzsBFjMAYg+gLnYl3JhtuR2Ldo5klM2fP39KTuBO8mfjuoWbcxw8Ye6YHxrwW7nEDABLK+hI/AXBW88yUe2EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/re-grad.png
// module id = 456
// module chunks = 0